import Card from '@packages/ui/card/card.tsx';
import CardHeader from '@packages/ui/card/card-header.tsx';
import CardContent from 'ui/src/card/card-content';
import FormLayout from 'ui/src/form/form-layout';
import MenuSelectionInput from 'ui/src/form/input/menu-selection-input';
import { useCompanyId } from 'core/src/company/focused-company-context';
import FormSection from '@packages/ui/form/form-section.tsx';
import { useTranslate } from '@tolgee/react';
import { Controller, useFormContext } from 'react-hook-form';
import { CompanyForm } from '@client/page/management/company-settings/company-settings.tsx';

const currencyType: string[] = ['VND', 'EUR', 'USD', 'CZK', 'SEK', 'PLN', 'CHF'];
const defaultLanguageType: string[] = ['en', 'vi', 'de', 'pl'];

export default function CompanyAdvancedSettings() {
  const { t } = useTranslate();
  const companyID = useCompanyId();

  const { control, getValues } = useFormContext<CompanyForm>();

  return (
    <Card>
      <CardHeader title={t('common.advanced-setting')} />

      <CardContent>
        <FormLayout>
          <FormSection title={t('common.companyID')} description={t('company-setting.company-description')}>
            <p className="font-semibold">{companyID}</p>
          </FormSection>

          <FormSection title={t('common.company-name')} description={t('company-setting.company-name')}>
            <p className="font-semibold">{getValues('name')}</p>
          </FormSection>

          <Controller
            name={'currency'}
            control={control}
            render={({ field }) => (
              <MenuSelectionInput
                title={t('common.currency')}
                data={currencyType}
                value={field.value}
                onChange={field.onChange}
                build={(item) => {
                  return {
                    id: item,
                    name: item,
                  };
                }}
                className="-my-2 w-full"
              />
            )}
          />

          <Controller
            name={'customerDefaultLanguage'}
            control={control}
            render={({ field }) => (
              <MenuSelectionInput
                title={t('company-setting.advanced.default-language', 'Default language')}
                data={defaultLanguageType}
                value={field.value}
                onChange={field.onChange}
                build={(item) => {
                  // Map language codes to country codes
                  const languageCountryMap = {
                    en: 'us',
                    vi: 'vn',
                    de: 'de',
                    pl: 'pl',
                  };
                  return {
                    id: item,
                    name: t('language.selector.' + item),
                    country: languageCountryMap[item as keyof typeof languageCountryMap],
                  };
                }}
                showFlag={true}
                className="-my-2 w-full"
              />
            )}
          />
        </FormLayout>
      </CardContent>
    </Card>
  );
}
